import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormMultiSelect from "../form/FormMultiSelect";
import TmwApi from "../../containers/Ticket/TmwApi";

class TmwTerminalSelect extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			terminals : [],
		};
	}
	componentDidMount() {
		const { getTerminalList } = this.props;

		getTerminalList({
			callback : (err, r) => {
				if (err) {
					return console.error(err);
				}
				this.setState({ terminals : r.terminals });
			}
		});
	}

	render () {
		let { value, terminalFilter } = this.props;
		const { terminals = []} = this.state;
		const filter = (terminalFilter) ? _.keyBy(terminalFilter) : undefined;
		let options = terminals.map(({terminal}) => {
			if (filter && !filter[terminal]) {
				// gets rid of previously selected values
				if (_.isArray(value) && _.includes(value, terminal)) {
					value = _.remove(value, terminal);
				}
				return null;
			}

			return {
				value: terminal ,
				display: terminal ,
			};
		});
		options = _.sortBy(_.compact(options), 'display');

		return (
			<FormMultiSelect
				{...this.props}
				// so an empty thing doesn't flicker in
				value={_.isEmpty(terminals) ? [] : value}
				options={options}
			/>
		);
	}
}

TmwTerminalSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.array,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	getTerminalList : PropTypes.func.isRequired,

	classes : PropTypes.object,
	helpText : PropTypes.string,
	billToFilter : PropTypes.array,
};

TmwTerminalSelect.defaultProps =  {
	label : 'Terminal',
	terminals : [],
};

export default TmwApi(TmwTerminalSelect);
